<template>
  <div id="okta-callback">
    <i class="el-icon-loading"></i>
  </div>
</template>

<script>
import tool from '@/tools/tools';
// eslint-disable-next-line import/no-cycle
import UsersService from '@/services/users.services';

export default {
  computed: {
    myPermissions() {
      return this.$store.getters['users/myPermissions'];
    },
  },
  async mounted() {
    const { code } = this.$route.query;

    if (!code) {
      this.$router.push({
        name: 'login',
        query: { error: 'sso_failed' },
      });
      return;
    }

    try {
      // Exchanges the one-time code for the session and loads /v1/me, so
      // permissions are populated before we decide where to send the user.
      await this.$store.dispatch('users/oktaLogin', code);
    } catch (e) {
      this.$router.push({
        name: 'login',
        query: { error: 'sso_failed' },
      });
      return;
    }

    // Same routing as a password login: PMs land on /home, everyone else on the
    // interface their permissions allow.
    tool.redirectUser(this.$router, this.myPermissions, UsersService);
  },
};
</script>

<style lang="scss"></style>
